import React from "react";
import Location from "../Icons/Location";

const JobModal = (props) => {
  const renderJobDesc = props.modalData.breif.map((val, i) => {
    return (
      <p key={val} className="py-3 text-sm text-Gray-400 font-opensans">
        {val.description}
      </p>
    );
  });

  const renderJobResponsibilityDesc = props.modalData.responsibilityDesc.map(
    (val, i) => {
      return (
        <p key={val} className="py-3 text-sm text-Gray-400 font-opensans">
          {val.description}
        </p>
      );
    }
  );

  const renderRequirement = props.modalData.requirement.map((val, i) => {
    return <li key={val}>{val.detail}</li>;
  });

  const renderResponsibilities = props.modalData.responsibilities.map(
    (val, i) => {
      return <li key={val}>{val.detail}</li>;
    }
  );

  const renderQualification = props.modalData.qualification?.map((val, i) => {
    return <li key={val}>{val.detail}</li>;
  });

  const renderProfile = props.modalData.profile.map((val, i) => {
    return <li key={val}>{val.detail}</li>;
  });

  const closeModal = () => {
    props.closeModalLayout();
    props.formRef.current.scrollIntoView();
    props.sendDataToParent(props.modalData.title);
  };

  return (
    <>
      <div className="md:max-w-screen-lg max-w-full mx-auto">
        <div className="flex flex-row justify-between">
          <h3 className="md:text-3xl text-xl text-Gray-900 font-avenirHeavy">
            {props.modalData.title}
          </h3>
          <div>
            <div className="flex flex-row items-center">
              {/* <div className="rounded p-1 px-1 border border-Gray-150 mx-5">
                <Forward className="cursor-pointer text-Gray-1000" />
              </div> */}
              <button className="brand-primary-sm-btn" onClick={closeModal}>
                Apply
              </button>
            </div>
          </div>
        </div>
        <div className="py-3 flex flex-row items-center ">
          <div className="flex flex-row items-center ">
            <Location width="20" height="20" className="text-Gray-600" />
            <span className="text-sm text-Gray-600 mx-2">
              {props.modalData.location}
            </span>
          </div>
          <div className="px-5">
            <span className="text-sm text-Gray-600">
              Experience{" "}
              <span className="font-bold">{props.modalData.experience}+</span>{" "}
              years
            </span>
          </div>
        </div>
        <div className="py-8">
          <div className="scroll-content">
            <h4 className="text-Gray-900 font-opensans font-bold text-sm">
              Job brief
            </h4>
            {renderJobDesc}
            <div className="py-8 skill-set-view-modal">
              <h4 className="text-Gray-900 font-opensans font-bold text-sm">
                Requirement
              </h4>
              <ul className="font-opensans text-sm text-Gray-600 pt-5">
                {renderRequirement}
              </ul>
            </div>

            <div className="pb-8 skill-set-view-modal">
              <h4 className="text-Gray-900 font-opensans font-bold text-sm">
                Responsibilities
              </h4>
              <div className="pt-3">{renderJobResponsibilityDesc}</div>
              <ul className="font-opensans text-sm text-Gray-600 pt-0">
                {renderResponsibilities}
              </ul>
            </div>
            <div className="pb-8 skill-set-view-modal">
              <h4 className="text-Gray-900 font-opensans font-bold text-sm">
                Personal Profile
              </h4>
              <ul className="font-opensans text-sm text-Gray-600 pt-0">
                {renderProfile}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default JobModal;
